import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';
import { NotificationsSDKWrapper } from 'src/sdk/api/wrapper/NotificationsSDKWrapper';

export default class NotificationsApiService extends AbstractApiService {
  // SDK migration pilot. Flip to false to fall back to the legacy axios path
  // (kept below) as a per-service kill-switch.
  protected useSdk = true;
  protected sdkWrapper = new NotificationsSDKWrapper();

  public constructor({}) {
    super({});
  }

  public async markNotificationAsRead(id: string): Promise<any> {
    if (this.useSdk && this.sdkWrapper) {
      return this.sdkWrapper.markNotificationAsRead(id);
    }
    const api_data: any = {};
    api_data['seen'] = String(true);
    return super.patch(api.notifications + id, api_data);
  }

  public async getNotifications(params: dynamicObj): Promise<any> {
    if (this.useSdk && this.sdkWrapper) {
      return this.sdkWrapper.getNotifications(params);
    }
    const querystring = this.encodeQueryData(params);
    return super.get(api.notifications + '?' + querystring, {});
  }
}
